__turbopack_context__.v({
  "link": "getAccountLockTypeVariant-module__PrbizG__link",
});
